module.exports = __webpack_public_path__ + "img/icon_dsjfxjfw.d4860c82.png";